import React from 'react';
import Pill from '@/components/ui/Pill';
import Text from '@/components/ui/Text';
import Icon from '@/components/ui/Icon';
import { DOMO_SHEETS } from './ImageInfo.constants';

interface LicensePillProps {
  licenseType?: string | null;
  isCollage?: boolean;
}

const LICENSE_TYPE_CONFIG: Record<string, string> = {
  'N/A': 'grey',
  NEEDS_REVIEW: 'red',
  PD: 'green',
  RF: 'yellow',
  RM: 'red',
  TCI: 'purple',
};

const normalizeLicenseType = (licenseType: string, isCollage: boolean = false): string => {
  if (isCollage) return 'NEEDS_REVIEW';
  if (!licenseType) return 'N/A';
  if (licenseType.includes('RF')) return 'RF';
  if (licenseType.includes('RM')) return 'RM';
  if (licenseType.includes('Single Use')) return 'RM';

  return licenseType;
};

const LicensePill = ({ licenseType, isCollage }: LicensePillProps) => (
  <Pill pillColor={LICENSE_TYPE_CONFIG[normalizeLicenseType(licenseType, isCollage)]}>
    {isCollage ? (
      <>
        <Text className="tw-mr-2">Multiple Assets: Needs Review</Text>
        <a
          className="tw-text-dark-grey hover:tw-text-tci-purple tw-cursor-pointer tw-mt-0.5 tw-mr-2"
          href={DOMO_SHEETS.collageImageAssets}
          rel="noopener noreferrer"
          target="_blank"
        >
          <Icon icon="ExternalLink" size={16} />
        </a>
      </>
    ) : (
      <Text size="sm">
        {licenseType ?? 'N/A'}
      </Text>
    )}
  </Pill>
);

export default LicensePill;
